var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboxRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 38H16.15L18.7625 43.2375C19.6125 44.9375 21.3375 46 23.2375 46H40.7625C42.65 46 44.3875 44.925 45.2375 43.2375L47.85 38H58V48C58 49.1 57.1 50 56 50H8C6.9 50 6 49.1 6 48V38ZM56.8125 32H47.2375C45.35 32 43.6125 33.075 42.7625 34.7625L40.15 40H23.85L21.2375 34.7625C20.3875 33.0625 18.6625 32 16.7625 32H7.1875L13.3125 7.5125C13.525 6.625 14.325 6 15.25 6H48.75C49.6625 6 50.4625 6.625 50.6875 7.5125L56.8125 32ZM0 36.9875V48C0 52.4125 3.5875 56 8 56H56C60.4125 56 64 52.4125 64 48V36.9875C64 36.3375 63.925 35.6875 63.7625 35.05L56.5125 6.0625C55.625 2.5 52.425 0 48.75 0H15.25C11.575 0 8.375 2.5 7.4875 6.0625L0.2375 35.05C0.075 35.675 0 36.325 0 36.9875Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxRegular);
export default __webpack_public_path__ + "static/media/inbox-regular.7154e366aa7a85ee266569ec1074ef17.svg";
export { ForwardRef as ReactComponent };